import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  heading: {
    display: 'flex',
    padding: '16px 24px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    background: colors.primaryBackground,
    color: colors.primaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '32px',
  },
  infoContainer: {
    display: 'flex',
    padding: '0px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  information: {
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Demi,
    fontSize: '18px',
    lineHeight: '24px',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  detailsTitle: {
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: '18px',
    lineHeight: '24px',
  },
  detailRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    alignSelf: 'stretch',
  },
  detailRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  detailLabel: {
    width: '80px',
    overflow: 'hidden',
    color: colors.secondaryText,
    textOverflow: 'ellipsis',

    fontFamily: fonts.din2014Regular,
    fontSize: '18px',
    lineHeight: '24px',
  },
  detailValue: {
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',

    fontFamily: fonts.din2014Demi,
    fontSize: '18px',
    lineHeight: '24px',
  },
  detailCost: {
    display: 'flex',
    alignSelf: 'center',
    overflow: 'hidden',
    color: 'var(--foreground-secondary, #61666C)',
    textOverflow: 'ellipsis',

    fontFamily: fonts.din2014Regular,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
  },
  actionContainer: {
    marginTop: 'auto',
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'flex-end',
    alignSelf: 'stretch',
    gap: '8px',
  },
});
